import React from 'react';
import T from 'prop-types';
import { connect } from 'react-redux';
import { ActionButton } from 'office-ui-fabric-react/lib/Button';
import { Persona, PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import { Callout } from 'office-ui-fabric-react/lib/Callout';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { getPhoto } from '../../Helpers/Helper';
import Image from '../../static/images/kapton-logo.png';
import '../../styles/bootstrap.css';

class UserCallout extends React.PureComponent {
  static propTypes = {
    userToken: T.object,
    show: T.bool,
    toggleCallout: T.func,
    logout: T.func,
    adminClick: T.func,  
    category: T.string
  };

  render() {
    const { userToken, show, toggleCallout, category } = this.props;
    const userName = userToken.userDetails ? userToken.userDetails.name : '';
    const userEmail = userToken.userDetails ? userToken.userDetails.userName : '';
    return (
      <div>
        {category === "profile" && show ?
          <Callout
            gapSpace={0}
            onDismiss={toggleCallout}
            headerText="My Account"
            role="dialog"
            setInitialFocus
            target="#_persona"
          >            
            <div className="popup-content userCallout">
              <div className='alignRight'>
                <ActionButton
                  data-automation-id="SignOut"
                  allowDisabledFocus
                  onClick={() => {this.props.logout()}}
                >
                  Sign out
                </ActionButton>
              </div>
              <div className='inlineFlex'>
                <div className="pa-UserCallout">
                  <Persona
                    size={PersonaSize.size72}
                    secondaryText={userName}
                    imageUrl={this.props.imageUrl}
                    hidePersonaDetails
                    className="myaccountPhoto"
                  />
                </div>
                <div className="pa-UserCallout">
                  <div className="pa-UserCalloutDetails">
                    <div className='title'>{userName}</div>
                    <div>{userEmail}</div>
                    <Link href="https://nam.delve.office.com/" target="_blank">
                      My profile
                    </Link>
                    <br />
                    <Link href="https://portal.office.com/account/" target="_blank">
                      My account
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </Callout> : null
        }
      </div>
    );
  }
}

class NavBar extends React.PureComponent {
  state = {
    isCalloutVisible: false,
    hideButtons: false,
    personaImageUrl: '',
    color: 'Default',
    previewColor: undefined,
    openTenantAlert: false,
    category: '',
    target: ''
  };

  static propTypes = {
    userToken: T.object,
    toggleMenu: T.func,
    logout: T.func,
  };

  toggleCallout = () => {
    this.setState(state => ({
      isCalloutVisible: !state.isCalloutVisible,
      category: state.category
    }));
  };

  componentDidMount() {
    const { userToken,tenantId } = this.props;
    if (userToken && userToken.userDetails) {
      getPhoto(`/users/${userToken.userDetails.userName}/photos/48x48/$value`, userToken.jwtAccessToken,'v1.0',tenantId).then(url => {
        this.setState({
          personaImageUrl: url,
        });
      });
    }

  }

  onClick = (category, target) => {
    this.setState({
      category: category,
      target: target
    });
    this.setState(state => ({
      isCalloutVisible: !state.isCalloutVisible,
    }));
  }

  showListApps = () => {
    //this.setShowPanelAppLauncher(true);
  };


  render() {
    const { userToken, logout, tenantId } = this.props;
    const userName = userToken && userToken.userDetails ? userToken.userDetails.name : '';
    const { isCalloutVisible, category, target } = this.state;
    return (
      <div id="teamHubNavbar" className="pca-NavBar">
        <div className="pca-NavBar-Menus">
          <div className="WaffleOffice365">
            <ActionButton
              data-automation-id="app"
              iconProps={{ iconName: 'WaffleOffice365' }}
              allowDisabledFocus
              onClick={this.showListApps}
            />
          </div>
          <div className="logo">
            <img rel="preload" src={Image} alt="Cyclotron" className="pca-Logo" />
          </div>
          {userToken && userToken.idToken &&
            <div className="rightControl rightNavbar">

              <div className="person rightProfile">
                <Persona
                  size={PersonaSize.size32}
                  imageAlt={userName}
                  text={userName ?? ""}
                  id="_persona"
                  onClick={() => this.onClick('profile', '#_persona')}
                  imageUrl={this.state.personaImageUrl}
                  className='userCalloutPersona'
                />
              </div>
              <UserCallout className='profileIcon'
                userToken={userToken}
                show={isCalloutVisible}
                toggleCallout={this.toggleCallout}
                logout={logout}
                target={target}
                imageUrl={this.state.personaImageUrl}
                category={category}
                tenantId={tenantId}
              />
            </div>
          }
        </div>

      </div>
    );
  }
}

const mapStateToProps = state => ({
  tenantId: state.app.TenantId,
});

export default connect(
  mapStateToProps,
)(NavBar);
